export enum GroupUserRoles {
    learner = 'learner',
    instructor = 'instructor',
}
